import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
//Redux imports below
import storeConfig from "./redux/storeConfig";
import { Provider } from "react-redux";
import { getAuth } from "./redux/actions/authActions";

const store = storeConfig();
store.dispatch(getAuth(true)); // loads user data and progresses data

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
